<div class="overLayDiv" [ngClass]="{'active' : (isOverlay && title) }"></div>
<div id="rightSideBar" [hidden]="!title">
    <div class="rightSidePanel active" [ngClass]="z_index_class">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <div>
                    <h2 [hidden]="selectedCount && !sub_title">{{ title }}</h2>
                    <small [hidden]="!selectedCount || !sub_title">
                        ({{selectedCount}} {{ sub_title }})
                    </small>
                </div>
                <h2 [hidden]="!selectedCount || sub_title">
                    {{ title }}: {{"label_selected" | translate}}
                    {{ selectedCount }}
                </h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" *ngFor="let item of buttonModel" [hidden]="hideActionButtons" class="{{item.buttonClass}}"
                    [ngClass]="{'disabled': (disableButtonsOnInvalid && isFormInvalid) || (item.disableWhenNotDirty && !isFormDirty) }"
                    (click)="onSubmit(item)" >
                    {{ item.buttonTooltip | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="onClose('close')">
                    {{ 'close' | translate}}
                </button>
            </div>
        </header>
        
        <div class="clear"></div>
        <dynamic-form *ngIf="formData" [(model)]="formModel" [fields]="formData">
        </dynamic-form>
    </div>
</div>